<script>
import Schema from '@/components/bundles/share/mixins/Schema.js'

export default {
  mixins: [
    Schema
  ],
  props: {
    service: {
      type: String,
      required: true
    }
  }
}
</script>
